import {NgModule} from '@angular/core';
// router stuff
import {RouterModule} from '@angular/router';

import {CommonModule} from '@angular/common';

import {AppFooterComponent} from './app-footer/app-footer.component';
import {AppHeaderComponent} from './app-header/app-header.component';
import {AppNavComponent} from './app-nav/app-nav.component';

import {PiwikService} from './services/piwik.service';
import {AuthGuard, LoginAuthGuard, PostLoginAuthGuard} from './services/auth-guard.service';
import {AuthService} from './services/auth.service';
import {StylesService} from './services/styles.service';
import {ErrorService} from './services/error.service';
import {DateService} from './services/date.service';
import {HistoryService} from './services/history.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    AppFooterComponent,
    AppHeaderComponent,
    AppNavComponent
  ],
  exports: [
    AppFooterComponent,
    AppHeaderComponent,
    AppNavComponent
  ],
  providers: [
    PiwikService,
    AuthGuard,
    LoginAuthGuard,
    PostLoginAuthGuard,
    AuthService,
    StylesService,
    ErrorService,
    DateService,
    HistoryService
  ]
})
export class CoreModule {
}
